import {Collision, getFirstCollision, UniqueIdentifier} from '@dnd-kit/core';
import {Coordinates} from '@dnd-kit/utilities';

interface DashboardDragDestinationOptions {
  collisions: Collision[] | null;
  keyboardOverId: UniqueIdentifier | null;
  pointerCoordinates: Coordinates | null;
}

// Not dnd-kit's `over`: it trails the pointer until its drag-over effect runs, which auto-scroll exposes.
export const getDashboardDragDestinationId = (options: DashboardDragDestinationOptions) =>
  options.pointerCoordinates === null
    ? options.keyboardOverId
    : getFirstCollision(options.collisions, 'id');
